import { useMemo } from "react";

import { t } from "@impero-com/common/utils/i18n";
import {
    AccessorFnColumnDef,
    getCoreRowModel,
    useReactTable,
} from "@tanstack/react-table";

import { ControlProgramTagView } from "api/generated/model";

export interface ControlProgramTagManagementOverview {
    tagId?: string;
    newTagName: string;
    action: string;
}

export const COLUMN_ID_NAME = "name";
export const COLUMN_ID_ACTION = "action";

export function useTable(
    tags: Omit<ControlProgramTagView, "controlProgramTagCategoryId">[],
    columns: AccessorFnColumnDef<ControlProgramTagManagementOverview, string>[]
) {
    const tableData: ControlProgramTagManagementOverview[] = useMemo(() => {
        const newTagInputRow: ControlProgramTagManagementOverview = {
            newTagName: "",
            action: t("ControlProgram_Tags_AddTag"),
        };
        return [
            newTagInputRow,
            ...tags.map((tag) => ({
                tagId: tag.id,
                newTagName: tag.name,
                action: t("TagManagementTable_Action_Delete"),
            })),
        ];
    }, [tags]);

    const table = useReactTable({
        data: tableData,
        columns,

        getCoreRowModel: getCoreRowModel(),
        enableSorting: false,
    });

    return table;
}
